import { render, staticRenderFns } from "./V-Variante.vue?vue&type=template&id=6908f1be&"
import script from "./V-Variante.vue?vue&type=script&lang=js&"
export * from "./V-Variante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports